"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _ = require(".");
var _util = require("../../util");
var CurrentPlan = function CurrentPlan(_ref) {
  var loanAmount = _ref.loanAmount,
    amount = _ref.amount,
    payment = _ref.payment,
    monthlyPayment = _ref.monthlyPayment,
    productType = _ref.productType,
    introTerm = _ref.introTerm,
    term = _ref.term,
    isInterestFree = _ref.isInterestFree,
    rate = _ref.rate;
  var _getLabels = (0, _.getLabels)(productType),
    paymentLabel = _getLabels.payment,
    period = _getLabels.period,
    apr = _getLabels.apr;
  var stats = [{
    key: 'amount',
    label: 'Amount financed',
    value: (0, _util.toDollar)(loanAmount || amount)
  }, {
    key: 'payment',
    label: paymentLabel,
    value: (0, _util.toDollar)(payment || monthlyPayment)
  }, {
    key: 'period',
    label: period,
    value: introTerm || term
  }, {
    key: 'apr',
    label: apr,
    value: isInterestFree ? '0%' : (0, _util.toPercent)(rate)
  }];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-current-plan"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "revisions-current-plan__header"
  }, "Your current plan"), /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-current-plan__stats"
  }, stats.map(function (stat) {
    return /*#__PURE__*/_react.default.createElement(_.Stat, stat);
  })), /*#__PURE__*/_react.default.createElement(_reactComponents.Divider, null));
};
CurrentPlan.propTypes = {
  loanAmount: _propTypes.default.string,
  amount: _propTypes.default.string,
  payment: _propTypes.default.string,
  monthlyPayment: _propTypes.default.string,
  productType: _propTypes.default.string.isRequired,
  introTerm: _propTypes.default.number,
  term: _propTypes.default.number,
  isInterestFree: _propTypes.default.bool,
  rate: _propTypes.default.number
};
CurrentPlan.defaultProps = {
  loanAmount: '',
  amount: '',
  payment: '',
  monthlyPayment: '',
  introTerm: 0,
  term: 0,
  isInterestFree: false,
  rate: ''
};
var _default = CurrentPlan;
exports.default = _default;
